import { render, staticRenderFns } from "./ykCopy.vue?vue&type=template&id=063fdb7a&scoped=true"
import script from "./ykCopy.vue?vue&type=script&lang=js"
export * from "./ykCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063fdb7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\smartlink\\front\\lianhe\\ctruck-lock-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('063fdb7a')) {
      api.createRecord('063fdb7a', component.options)
    } else {
      api.reload('063fdb7a', component.options)
    }
    module.hot.accept("./ykCopy.vue?vue&type=template&id=063fdb7a&scoped=true", function () {
      api.rerender('063fdb7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/YkFormComponet/ykCopy.vue"
export default component.exports